import {Radio, showNotification} from 'platform/components';
import {Space} from 'platform/foundation';

import {
  BranchPreselectionRecordType,
  BranchPreselectionSchema,
  useGetBranchPreselectionQuery,
  usePutBranchPreselectionMutation,
} from '@dms/api/settings';
import i18n from '@dms/i18n';
import {handleApiError} from '@dms/shared';

import {TestIdProps} from 'shared/web';

interface BranchPreselectionSectionProps extends TestIdProps {
  recordType: BranchPreselectionRecordType;
  label: string;
}

const getBranchPreselectionOptions = () => [
  {label: i18n.t('entity.branch.labels.selectedBranch'), value: 'SELECTED_BRANCH'},
  {label: i18n.t('entity.branch.labels.vehicleBranch'), value: 'VEHICLE_BRANCH'},
];

export function BranchPreselectionSection(props: BranchPreselectionSectionProps) {
  const {data, isLoading, isError} = useGetBranchPreselectionQuery({recordType: props.recordType});
  const [putBranchPreselection, {isLoading: isSaving}] = usePutBranchPreselectionMutation();

  const handleChange = (value: string | null) => {
    const parsedValue = BranchPreselectionSchema.safeParse(value);

    if (!parsedValue.success) {
      return;
    }

    putBranchPreselection({
      recordType: props.recordType,
      branchPreselectionSettingsRequestBody: {branchPreselection: parsedValue.data},
    })
      .unwrap()
      .then(() => showNotification.success(i18n.t('general.notifications.changesSaved')))
      .catch(handleApiError);
  };

  return (
    <>
      <Radio
        label={props.label}
        helperText={i18n.t('page.salesSettings.branchPreselection.helperText')}
        value={data?.branchPreselection ?? null}
        onChange={handleChange}
        // Saving without a loaded value would report success next to an empty radio
        isDisabled={isLoading || isError || isSaving}
        options={getBranchPreselectionOptions()}
        data-testid={props['data-testid']}
      />
      <Space vertical={3} />
    </>
  );
}
